// extracted by mini-css-extract-plugin
export default {"infoTooltip":"info-tooltip_infoTooltip__3MkSa"};